import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { SetRequirePasscodeConfirmationRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { SetRequirePasscodeConfirmationResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const setRequirePasscodeConfirmation = (
  request: SetRequirePasscodeConfirmationRequest,
  options?: CashRequestOptions
) =>
  post<SetRequirePasscodeConfirmationRequest, SetRequirePasscodeConfirmationResponse>(
    '/2.0/cash/set-require-passcode-confirmation',
    request,
    { ...options, rejectOnError: true }
  )
